/**
 * The board module's frontend manifest — everything it adds to the interface,
 * in one place. The backend half is `backend/src/modules/board/`.
 */
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import { BOARD_PERMISSIONS } from '@forsys/shared';
import { defineDashboardCard, defineFrontendModule } from '../types';
import BoardsPage from './BoardsPage';
import { boardOptions, DashboardBoards, type BoardCardConfig } from './DashboardBoards';

// A session is enough: everybody sees their own groups' boards.
const boardCard = defineDashboardCard<BoardCardConfig>({
  id: 'board',
  titleKey: 'board:dashboard.title',
  icon: CampaignOutlinedIcon,
  component: DashboardBoards,
  width: 3,
  minWidth: 1,
  maxWidth: 3,
  order: 200,
  defaultConfig: { board: 'all' },
  settings: [{ kind: 'select', key: 'board', labelKey: 'board:dashboard.board', options: boardOptions }],
  // One card with every board; a card for one group's board is added by hand.
  defaults: () => [{ key: 'all', config: { board: 'all' } }],
});

export const boardModule = defineFrontendModule({
  key: 'board',
  pages: [
    {
      path: 'boards',
      element: <BoardsPage />,
      anyOf: [BOARD_PERMISSIONS.UPDATE],
      nav: { section: 'content', labelKey: 'board:nav.boards', icon: CampaignOutlinedIcon },
    },
  ],
  dashboardCards: [boardCard],
});
